import { setPageTitle, share, initNavbarShare } from './action';
import { pagetransNative } from './pagetrans';
import { iosOutsideOpenApp, androidOutsideOpenApp } from '../../jsBridge/sdk/openApp';
import { IS_LIGHT, IS_IOS, IS_WECHAT } from '../../constants';

export {
  setPageTitle,
  pagetransNative,
  share,
  initNavbarShare,
};

/**
 * 判断跳转的协议是安卓、ios、站外
 * @param {object} param 跳转参数
 * @return {array}
 */
export const jump = (param = {}) => {
  if (IS_LIGHT) {
    pagetransNative(param);
  } else {
    if (IS_IOS) {
      const iosUrl = iosOutsideOpenApp(param);
      return [iosUrl[0], iosUrl[1]];
    }
    const androidUrl = androidOutsideOpenApp(param);
    const isWechatAndroid = !!IS_WECHAT;
    return [androidUrl[0], androidUrl[1], isWechatAndroid];
  }
  return [];
};
